module.exports = __webpack_public_path__ + "img/logo.ed2e5b36.jpg";